import { Pipe, PipeTransform } from "@angular/core";

@Pipe(
    {
        name: 'filterCatalog',
        pure: true
    })

export class FilterCatalogPipe implements PipeTransform {
    constructor() {
    }

    transform(secondaryCatalog: Array<any>, query: any, targetAttribute: string) {
        if (!secondaryCatalog || !query || !targetAttribute) {
            return [];
        }

        let itemsSeleccionados = secondaryCatalog;

        itemsSeleccionados = secondaryCatalog.filter((item: any) => {
            return item[targetAttribute] == query;
        });

        return itemsSeleccionados;
    }
}